import React from 'react';
import { Tooltip, Flex } from 'antd';
import { truncateByLength } from '@/common/helper';

interface Team {
  color: string;
  name: string;
}

interface WhoCanSeeTooltipProps {
  teams: Team[];
  children: React.ReactNode;
}

const WhoCanSeeTooltip: React.FC<WhoCanSeeTooltipProps> = ({
  teams,
  children,
}) => {
  const content = (
    <div className='who-can-see-tooltip'>
      <div className='zl-heading-12 gray-5e mb-2'>Who can see</div>

      {teams.map((team, index) => (
        <Flex key={index} align='center' gap={8} style={{ marginBottom: 6 }}>
          <span
            className='team-color-circle'
            style={{
              backgroundColor: team?.color,
            }}
          />
          <span className='zl-para-400-12'>
            {truncateByLength(team?.name, 18)}
          </span>
        </Flex>
      ))}
    </div>
  );

  return (
    <Tooltip
      title={content}
      placement='right'
      color='transparent'
      overlayInnerStyle={{ padding: 0 }}
    >
      {children}
    </Tooltip>
  );
};

export default WhoCanSeeTooltip;
